<template>
  <div class="recipient-key">
    <p>
      {{ keyLbl }}

      <a
        href="#"
        class="badge badge-secondary"
        v-on:click="onStatusClick"
        data-status-type="created_at"
      >
        All
      </a>

      <a
        href="#"
        class="badge badge-warning"
        v-on:click="onStatusClick"
        data-status-type="queued_at"
      >Queued</a>

      <a
        href="#"
        class="badge badge-info"
        v-on:click="onStatusClick"
        data-status-type="sent_at"
      >Relayed</a>

      <a
        href="#"
        class="badge badge-success"
        v-on:click="onStatusClick"
        data-status-type="last_delivered_at"
      >Delivered</a>

      <a
        href="#"
        class="badge badge-danger"
        v-on:click="onStatusClick"
        data-status-type="last_bounced_at"
      >Bounced</a>

      <a
        href="#"
        class="badge badge-dark"
        v-on:click="onStatusClick"
        data-status-type="last_complained_at"
      >Complained</a>
    </p>
  </div>
</template>
<script>
export default {
  props: {
    keyLbl: {
      type: String,
      default: 'Filter By:'
    },

    status: {
      type: String,
      default: undefined
    }
  },

  computed: {
    bounced () {
      return 'danger'
    },

    complained () {
      return 'dark'
    },

    delivered () {
      return 'success'
    },

    queued () {
      return 'warning'
    },

    sent () {
      return 'info'
    }
  },

  methods: {
    onStatusClick (ev) {
      this.$emit('statusTypeSelected', ev.target.dataset.statusType)
    },

    recipientClass (recipient) {
      let className = this.queued
      if (this[recipient.status]) {
        className = this[recipient.status]
      } else {
        if (recipient.last_complained_at) {
          className = this.complained
        } else if (recipient.last_delivered_at) {
          className = this.delivered
        } else if (recipient.sent_at) {
          className = this.sent
        }

        // If it's bounced, verify that it hasn't been redelivered.
        if (recipient.last_delivered_at < recipient.last_bounced_at) {
          className = this.bounced
        }
      }

      return 'list-group-item-' + className
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EmailRecipientStatusKey.vue